import backgroundThumbnail from '../../assets/images/attachment.jpeg'
import { _$ } from '../../utils/dom'

export const IdeaAttachement = ({ type, link, size, remainingCount, setAttachmentsToListModel, attachmentIndex }) => {

    if (type == '.png' || type == '.jpg' || type == '.jpeg') {

        return (
            <>
                <div className={size} data-toggle="modal" data-target="#listModal" role="button" onClick={e => {
                    setAttachmentsToListModel(attachmentIndex)
                }}>
                    <div className="card cen h-200p" style={{ backgroundImage: `url("${link}")` }}>
                        {remainingCount && (<div className="card-body">
                            <div className="avatar bg-transparent border-0 font-20">+{remainingCount}</div>
                        </div>)}
                    </div>
                </div>
            </>
        )
    }
    else if (type == '.mp4') {
        return (
            <>
                <div className={size} data-toggle="modal" data-target="#listModal" role="button" onClick={e => {
                    setAttachmentsToListModel(attachmentIndex)
                }}>
                    <div className="card cen h-200p" style={{ backgroundImage: `url(${backgroundThumbnail})` }}>
                        <div className="card-body">
                            {remainingCount ? (<div className="avatar bg-transparent border-0 font-20">+{remainingCount}</div>) : (<div className="avatar">
                                <div className="avatar-content">
                                    <i className="fas fa-play"></i>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>
            </>
        )
    }
    else if (type == '.pdf') {
        return (
            <>
                <div className={size} data-toggle="modal" data-target="#listModal" role="button" onClick={e => {
                    setAttachmentsToListModel(attachmentIndex)
                }}>
                    <div className="card cen h-200p" style={{ backgroundImage: `url(${backgroundThumbnail})` }}>
                        <div className="card-body">
                            {remainingCount ? (<div className="avatar bg-transparent border-0 font-20">+{remainingCount}</div>) : (<div className="avatar">
                                <div className="avatar-content">
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>
            </>
        )
    }
    else if (type == ".mp3") {
        return (
            <>
                <div className={size} data-toggle="modal" data-target={"#listModal"} role="button" onClick={e => {
                    setAttachmentsToListModel(attachmentIndex)
                }}>

                    <div className="card cen h-200p" style={{ backgroundImage: `url(${backgroundThumbnail})` }}>
                        <div className="card-body">
                            {remainingCount ? (<div className="avatar bg-transparent border-0 font-20">+{remainingCount}</div>) : (<div className="avatar">
                                <div className="avatar-content">
                                    <i className="fas fa-music"></i>
                                </div>
                            </div>)}

                        </div>
                    </div>
                </div>
            </>
        )
    }
}